angular.module('ikeweb.spike.capture').value('CaptureImageExport',
    function CaptureImageExport(capture, offset) {

        var self = this;
        var resolution = capture.resolution;

        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        var canvasWidth = offset ? offset.width : resolution.width;
        var canvasHeight = offset ? offset.height : resolution.height;
        var offsetLeft = offset ? offset.left : 0;
        var offsetTop = offset ? offset.top : 0;

        canvas.setAttribute('width', canvasWidth);
        canvas.setAttribute('height', canvasHeight);

        function normalizeSVGforCanvg(svg) {
            // Fix for canvg nested-opacity bug: https://github.com/canvg/canvg/issues/510
            return svg.replace(/opacity\s*=\s*"0"/g, 'display="none"');
        }

        function drawSVG(svg) {
            var normalizedSVG = normalizeSVGforCanvg(svg);

            var svgCanvas = document.createElement('canvas');
            var svgContext = svgCanvas.getContext('2d');
            svgCanvas.setAttribute('width', resolution.width);
            svgCanvas.setAttribute('height', resolution.height);

            svgContext.drawSvg(normalizedSVG, 0, 0, resolution.width, resolution.height);

            return svgCanvas;
        }

        function drawImage(context, image) {
            context.drawImage(image,
                offsetLeft,
                offsetTop,
                canvasWidth,
                canvasHeight,
                0,
                0,
                canvasWidth,
                canvasHeight
            );
        }

        this.addImage = function(image) {
            drawImage(context, image);
            return self;
        };

        this.addMeasurements = function() {
            drawImage(context, drawSVG(capture.getMeasurementsSVGString()));
            return self;
        };

        this.getFilename = function() {
            return capture.getExportFilename() + '.jpg';
        };

        this.getURL = function() {
            return null;
        };

        this.getData = function() {
            var png = canvas.toDataURL('image/jpeg', 0.5).split(',')[1];
            var binStr = atob(png);

            var buf = new ArrayBuffer(binStr.length);
            var view = new Uint8Array(buf);
            for (var i = 0; i < view.length; i++) {
                view[i] = binStr.charCodeAt(i);
            }

            var blob = new Blob([view], {
                type: 'image/jpeg'
            });
            return blob;
        };

    });



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/capture/capture.image.export.js
// module id = 518
// module chunks = 0